/**
 * Builds a SQL-like `WHERE` clause string by interpolating form field values into a template.
 *
 * This utility replaces placeholders in the form `{field}` with corresponding values from `form`.
 * It also supports a special helper syntax `{field__FIRSTWORD}` or `{field__!FIRSTWORD}` to extract
 * only the first word (or everything except the first word) from a form input.
 */

export function buildWhere(template: string, form: Record<string, string>) {
    const withHelpers = template.replace(/\{(\w+)__(!)?FIRSTWORD\}/g, (_, name, not) => {
        const v = (form[name] || "").trim();
        if (!v) return "";
        const [first, ...rest] = v.split(/\s+/);
        return not ? rest.join(" ") : first;
    });
    return withHelpers.replace(/\{(\w+)\}/g, (_, name) => (form[name] ?? ""));
}
